import { AUTHORABLE_FIELD_TYPES } from './authorable-field-types.js';
const AUTHORABLE_FIELD_TYPE_SET = new Set(AUTHORABLE_FIELD_TYPES);
export function isAuthorableFieldType(typeId) {
    return AUTHORABLE_FIELD_TYPE_SET.has(typeId);
}
//# sourceMappingURL=is-authorable-field-type.js.map